<template>
  <div class="grid__order" v-show="showingCompleted == completed">
    <div class="order__header" @click="toggleAllItems()">
      <div class="header__checkbox" v-if="!completed"></div>
      <svgicon class="header__check" src="icon/check-circle-full.svg" :width="24" :height="24" v-else></svgicon>
      <div class="header__left">
        <div class="header__top">#123456</div>
        <div class="header_bottom">R-Center-01</div>
      </div>
      <div class="header__right">
        <div class="header__top">9:17 AM</div>
        <div class="header__bottom">Take-out | {{ elapsed.format("mm") }} m</div>
      </div>
      <div class="header__actions" @click.stop="$emit('showModal')">
        <svgicon src="/icon/details_plus.svg" :width="24" :height="24"></svgicon>
      </div>
    </div>
    <div class="order__body" :class="{ noclick: completed }">
      <KDSItem ref="item1" @completed="checkAllItemsCompleted"></KDSItem>
      <div class="body__separator"></div>
      <KDSItem ref="item2" @completed="checkAllItemsCompleted"></KDSItem>
      <div class="body__separator"></div>
      <KDSItem ref="item3" @completed="checkAllItemsCompleted"></KDSItem>
      <div class="body__separator dashed"></div>
      <div class="body__more">4 more items</div>
    </div>
  </div>
</template>

<script>
  import KDSItem from "@/components/pos/KDSItem.vue";
  import moment from "moment";

  export default {
    components: { KDSItem },
    props: {
      showingCompleted: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        completed: false,
        created: moment(),
        now: moment(),
        interval: null
      };
    },
    mounted() {
      this.interval = setInterval(() => {
        if (!this.completed) {
          this.now = moment();
        }
      }, 100);
    },
    beforeDestroy() {
      clearInterval(this.interval);
    },
    computed: {
      elapsed() {
        return moment(this.now.diff(this.created));
      }
    },
    methods: {
      toggleAllItems() {
        this.completed = !this.completed;
        if (this.$refs.item1.completed !== this.completed) {
          this.$refs.item1.toggleItem();
        }
        if (this.$refs.item2.completed !== this.completed) {
          this.$refs.item2.toggleItem();
        }
        if (this.$refs.item3.completed !== this.completed) {
          this.$refs.item3.toggleItem();
        }
        if (!this.completed) {
          this.created = moment();
          this.now = moment();
        }
        this.$forceUpdate();
      },
      checkAllItemsCompleted() {
        if (this.$refs.item1.completed && this.$refs.item2.completed && this.$refs.item3.completed) {
          this.completed = true;
        }
        this.$forceUpdate();
      }
    }
  };
</script>

<style lang="scss" scoped>
.grid__order {
  background-color: white;
  border-radius: 20px;
  box-shadow: 0 5px 15px #0000001A;
  min-height: 0;
  overflow: visible;
  display: flex;
  flex-direction: column;
}

.order__header {
  background-color: var(--primary-color);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  color: white;

  .header__checkbox {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 3px solid white;
    margin-right: 20px;
  }

  .header__check {
    margin-right: 20px;
    fill: white;
  }

  .header__left {
    flex-grow: 1;
  }

  .header__right {
    text-align: right;
  }

  .header__top {
    font-size: 24px;
    font-weight: 900;
  }

  .header__bottom {
    font-weight: 500;
  }

  .header__actions {
    margin-left: 20px;
    cursor: pointer;
  }
}

.order__body {
  display: grid;
  gap: 15px 10px;
  padding: 20px;
  align-items: center;
  overflow-y: auto;
  min-height: 0;
  max-height: 100%;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;

  &.noclick * {
    pointer-events: none;
  }

  .body__separator {
    border-bottom: 1px solid #E6E6E6;

    &.dashed {
      border-bottom: 1px dashed #E6E6E6;
    }
  }

  .body__more {
    font-size: 16px;
    color: var(--primary-color);
    text-align: center;
    font-weight: 500;
  }
}
</style>